import { render, staticRenderFns } from "./ApexDefinitions.vue?vue&type=template&id=5066a4fc&scoped=true&"
import script from "./ApexDefinitions.vue?vue&type=script&lang=js&"
export * from "./ApexDefinitions.vue?vue&type=script&lang=js&"
import style0 from "./ApexDefinitions.vue?vue&type=style&index=0&id=5066a4fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066a4fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VRow})
